import { createSelector } from 'reselect'
import { ICapabilities } from '../types/capabilties'
import { ICapability } from '../types/capability'
import { IGroupDetailed } from '../types/group'
import { AppStateType } from '../reducers'
import { selectGroup } from './group'
import { matchId } from '../services/common'

export const selectCapability = createSelector(
  [(state: AppStateType) => state.capability],
  (capability: ICapability) => capability
)

export const selectCapabilities = createSelector(
  [(state: AppStateType) => state.capabilities],
  (capabilities: ICapabilities) =>
    capabilities && capabilities.list && capabilities
)

export const selectSortedCapabilitiesBySelectedToGroup = createSelector(
  [selectCapabilities, selectGroup],
  (capabilities: ICapabilities, group: IGroupDetailed): ICapabilities => ({
    ...capabilities,
    list: [
      ...capabilities.list.filter(({ id }) =>
        group.capabilities.some(matchId(id))
      ),
      ...capabilities.list.filter(
        ({ id }) => !group.capabilities.some(matchId(id))
      ),
    ],
  })
)
